// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AudiencesPage from './pages/AudiencesPage';
import AiPage from './pages/AiPage';
import AttributionPage from './pages/AttributionPage';
import './App.css';
import './styles/global.css';

function App() {
  return (
    <Router>
      <div className="App">
      <Routes>
        {/* Main pages */}
        <Route path="/audiences" element={<AudiencesPage />} />
        <Route path="/ai" element={<AiPage />} />
        <Route path="/attribution" element={<AttributionPage />} />
        
        {/* Root path shows blank/black page */}
        {/* <Route path="/" element={<div style={{backgroundColor: 'black', height: '100vh'}}></div>} /> */}
        <Route path="/" element={<Navigate to="/attribution" replace />} />
        
        {/* Catch all other routes - redirect to blank page */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </div>
    </Router>
  );
}

export default App;